import { z } from 'zod';

/**
 * RFC 9457 Problem Details (application/problem+json) as ExceptionHandling::ProblemDetails.build
 * renders them; mirrors the `problem_json` OpenAPI schema (ExceptionHandling::ProblemJsonSchema).
 *
 * The DEFAULT schema for an error body. The server always renders all seven members and none of
 * them is ever null: `type` and `detail` are `to_s`-coerced, a blank `title` falls back to the HTTP
 * status text, a blank `instance` to `urn:obseed:request:<request_id>` and a blank `request_id` to
 * a fresh UUID. So every member is required and non-nullable here. Extension members (`errors`,
 * `count`, …) sit flat at the top level, so the object passes unknown keys through instead of being
 * strict; `exception` only appears in the local env.
 *
 * For a body from a path that is not yet RFC 9457 conformant (proxy errors, legacy controllers),
 * fall back to LegacyProblemJsonSchema.
 */
export const ProblemJsonSchema = z
  .object({
    type: z.string(),
    title: z.string(),
    status: z.number().int(),
    detail: z.string(),
    instance: z.string(),
    request_id: z.string(),
    code: z.string(),
  })
  .passthrough();

export type TProblemJson = z.infer<typeof ProblemJsonSchema>;
